/**
 * testConstants.js
 */

/**
 * The list of commands that are meant to be sent to one specific aircraft that is selected by the user from the radar scope.
 * 
 * @property TEST_COMMAND_WHITELIST
 * @type {array<string>}
 * @final
 */
export const TEST_COMMAND_WHITELIST = [
    'makeGuess',
    'addText'
]